import Swiper from 'swiper/dist/js/swiper.min';

export default class Brief {
  constructor(parent) {
    const sliderContainer = parent.querySelector('.brief__container');
    const slides = [].slice.call(parent.querySelectorAll('.brief__item'));
    const sliderOptions = {
      pagination: {
        el: parent.querySelector('.brief__pagination'),
        clickable: true,
      },
      breakpointsInverse: true,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1280: {
          slidesPerView: 4,
        },
      },
    };

    if (sliderContainer && slides.length) {
      new Swiper(sliderContainer, sliderOptions);
    }
  }
}



// WEBPACK FOOTER //
// ./blocks/brief/brief.js